/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = AwaitingForAuthorization
 *
 * 2 = InProgress
 *
 * 3 = PartsInOrder
 *
 * 4 = Done
 */
export enum VehicleAccidentRepairStatusEnum {
  "Awaiting for Authorization" = 1,
  InProgress = 2,
  PartsInOrder = 3,
  Done = 4,
}
